<hr />
<h2 class="mb-4">Agreement</h2>

<ng-container *ngIf="ready" [formGroup]="form">

  <div>
    <label for="slaAgreement" class="required mt-0">
      <p-checkbox [formControlName]="'slaAgreement'" id="slaAgreement" [required]="true" #slaAgreement
        label="Terms & Conditions" [binary]="true"></p-checkbox>
    </label>
    <div *ngIf="submitted && form?.controls?.slaAgreement?.invalid">
      <span class="text-danger">
        Please read the Registrant Sublicense Agreements and click on the box to accept.
      </span>
    </div>

  </div>
  <div class="ms-4 mt-2">
    I have read and accept the <a [href]="licenseAgreementcontent" target="_blank">Short Code Registry's Registrant Sublicense Agreement</a> (last updated {{licenseAgreementUpdated}})
  </div>
  <div class="ms-4 mt-2">
    I acknowledge and agree that by clicking to accept the Registrant Sublicense Agreement that I am solely responsible for the accuracy
      and completeness of the information provided to the Short Code Registry, including without limitation my application information.
    </div>
    <br>
    <div>
      <label for='bestPractices' class="required mt-0">
          <p-checkbox [formControlName]="'bestPractices'" name="bestPractices" id="bestPractices" [required]="true"
            label="Best Practices" [binary]="true"></p-checkbox>
      </label>
      <div class="error-msg" *ngIf="submitted && form?.controls?.bestPractices?.invalid">
          <span class="text-danger">
              Please read the Messages Principles and Best Practices document and click on the box to accept.
          </span>
      </div>
  </div>
  <div class="ms-4 mt-2">
    I have read and accept the &nbsp;
    <a [href]="bestPracticesContent" target="_blank">
        Messaging Principles and Best Practices
    </a> &nbsp; (last updated {{ bestPracticesDate }})
</div>
</ng-container>